import { render, staticRenderFns } from "./MemberRequestExtract.vue?vue&type=template&id=6bc91e7e&scoped=true&"
import script from "./MemberRequestExtract.vue?vue&type=script&lang=js&"
export * from "./MemberRequestExtract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc91e7e",
  null
  
)

export default component.exports